<app-header [ngClass]="{'d-none': router.url === '/coming-soon'}"></app-header>
<app-cookies *ngIf="!cookiesAceptadas()"></app-cookies>
<div id="componente" class="componente">
  <router-outlet class="componente-renderizado"></router-outlet>
</div>
<app-footer *ngIf="!isLoginPage()" [ngClass]="{'d-none': router.url === '/coming-soon'}"></app-footer>
<ngx-scrolltop [ngClass]="{'d-none': router.url === '/coming-soon'}"></ngx-scrolltop>
